import LogRocket from "logrocket";
import moment from "moment-timezone";

import { api } from "@/APIRequests";
import { httpAuth } from "@/utils/axios";

import * as actionTypes from "./actionTypes";

const loadAssessment = (startQuestion, assessmentPerc) => {
  return {
    payload: { assessmentPerc, startQuestion },
    type: actionTypes.START_ASSESSMENT,
  };
};

const nextQuestion = (nextQuestion, isLast, assessmentPerc) => {
  return {
    payload: { assessmentPerc, isLast, nextQuestion },
    type: actionTypes.NEXT_QUESTION,
  };
};

const previousQuestion = (payload) => {
  return {
    payload,
    type: actionTypes.PREVIOUS_QUESTION,
  };
};

const selectOption = (options) => {
  return {
    payload: options,
    type: actionTypes.OPTION_SELECTED,
  };
};

const setAssessmentStatus = (status) => {
  return {
    payload: status,
    type: actionTypes.SET_ASSESSMENT_STATUS,
  };
};

export const startAssessment = (assessmentType, errorTypeConfig) => (dispatch) => {
  let promise = null;

  if (assessmentType === "post_90_day") {
    promise = api.patient.start_outcome_assessment();
  } else {
    let data = {};

    if (assessmentType != null && assessmentType !== "") {
      data["assessment_type"] = assessmentType;
    }

    promise = api.patient.get_next_question({ data, errorTypeConfig });
  }

  promise.then((cleanResponse) => {
    if (!cleanResponse) {
      dispatch({ type: actionTypes.NO_ASSESSMENT });
    } else {
      let question = cleanResponse.question;

      if (question == null) {
        dispatch({ type: actionTypes.START_RATING_SCALE });
      } else {
        let assessmentPerc = cleanResponse.percentage;

        dispatch(loadAssessment(cleanResponse.question, assessmentPerc));
      }
    }
  });
};

export const getNextQuestion = (requestBody, assessmentType, errorTypeConfig) => (dispatch) => {
  let request =
    "post_90_day" !== assessmentType
      ? api.patient.submit_question
      : api.patient.fetch_next_outcome_question;

  request({ data: requestBody, errorTypeConfig }).then((cleanResponse) => {
    if (cleanResponse === null) {
      dispatch({ type: actionTypes.ASSESSMENT_COMPLETED });
      console.error("Unexpected response from assessment submit_question");
      LogRocket.captureMessage("Unexpected response from assessment submit_question");

      return;
    }
    let nextQ = cleanResponse.question;
    let assessmentPerc = cleanResponse.percentage;
    let isLast = (cleanResponse.question && cleanResponse.question.is_last) || false;

    if (nextQ == null) {
      dispatch({ type: actionTypes.ASSESSMENT_COMPLETED });
    } else {
      dispatch(nextQuestion(nextQ, isLast, assessmentPerc));
    }
  });
};

export const getPreviousQuestion = (assessmentType, lastQuestionErrorTypeConfig) => (dispatch) => {
  let promise = null;

  if (assessmentType === "post_90_day") {
    promise = api.patient.fetch_previous_outcome_question();
  } else {
    let data = {};

    if (assessmentType != null && assessmentType !== "") {
      data["assessment_type"] = assessmentType;
    }

    promise = api.patient.get_last_question({
      data,
      errorTypeConfig: lastQuestionErrorTypeConfig,
    });
  }

  promise.then((cleanResponse) => {
    let assessmentPerc = cleanResponse.percentage;
    let payload = {
      assessmentPerc,
      currentQuestion: cleanResponse.question,
    };

    dispatch(previousQuestion(payload));
  });
};

export const getAssessmentStatus = (options) => (dispatch) => {
  options = { params: { showLoader: false } };
  api.patient.fetch_assessment_status({ options }).then((cleanResponse) => {
    let status = cleanResponse.user;

    dispatch(setAssessmentStatus(status));
  });
};

export const setSelectedOptions = (selectedOptions, selectedOptionFull) => (dispatch) => {
  dispatch(selectOption({ selectedOptionFull, selectedOptions }));
};

export const submitRatingScaleQuestions = (data) => (dispatch) => {
  return api.patient.submit_rating_scale_questions({ data }).then(() => {
    dispatch({ type: actionTypes.ASSESSMENT_COMPLETED });
  });
};

export const updateScheduleList = () => (dispatch) => {
  api.schedule
    .get_schedule({
      options: {
        params: {
          showLoader: false,
        },
        queryParams: {
          local_start_date_time: moment().startOf("day").format("YYYY-MM-DD HH:mm"),
          timezone: moment.tz.guess(),
        },
      },
    })
    .then((response) => {
      dispatch({
        payload: {
          scheduleList: response.schedule || [],
        },
        type: actionTypes.UPDATE_SCHEDULE_LIST,
      });
    })
    .catch(() => {
      dispatch({
        payload: {
          scheduleList: [],
        },
        type: actionTypes.UPDATE_SCHEDULE_LIST,
      });
    });
};

export const updateCrisisRisk = (data) => {
  return {
    payload: {
      crisisRisk: data,
    },
    type: actionTypes.UPDATE_CRISIS_RISK,
  };
};

export const allowLoginPopUps = () => {
  const payload = {
    allowInactivePopUp: true,
    allowWaitListPopUp: true,
  };

  return {
    payload,
    type: actionTypes.ALLOW_LOGIN_POP_UPS,
  };
};

export const disableLoginPopUps = () => {
  return {
    type: actionTypes.DISABLE_LOGIN_POP_UPS,
  };
};

// ----------- Thunks --------------

export const fetchAssessmentCrisisRisk = async ({ dispatch, options, urlParams } = {}) => {
  const urlQueryString = urlParams ? new URLSearchParams(urlParams) : "";
  let conf = {
    method: "post",
    url: `/v1/a5_screening/get_crisis_risk?${urlQueryString}`,
    ...options,
  };

  return httpAuth(conf).then((data) => {
    dispatch(updateCrisisRisk(data));

    return data;
  });
};
